import { useSelector } from 'react-redux'

const useActiveCompany = () => {
  const { is_active: isActiveCompany } = useSelector(({ company }) => company)

  return isActiveCompany
}

export default useActiveCompany
